<template>
  <div
    v-if="sections"
    id="checkoutVue"
    class="checkout-vue-form"
  >
    <section
      :is="section.component"
      v-for="(section, i) in sections"
      :key="section.key"
      :number="i - number"
    />
  </div>
</template>

<script>
import AddOns from './add_ons'
import TableAddOns from './table_display_add_ons/add_ons'
import Address from './address'
import HotelDetails from './hotel_details'
import Cart from './sidebar_cart'
import Payment from './payment'
import Review from './review'
import { mapMutations, mapState } from 'vuex'

export default {
  components: {
    Address,
    AddOns,
    Cart,
    HotelDetails,
    Payment,
    Review
  },

  data() {
    const addOn = ( window.checkout_version === 'table_display' ?
      TableAddOns : AddOns)
    return {
      currentSection: 'none',
      sections: [
        { key: 'Cart', component: Cart },
        { key: 'AddOns', component: addOn },
        { key: 'Address', component: Address },
        { key: 'Hotel', component: HotelDetails },
        { key: 'Review', component: Review },
        { key: 'Payment', component: Payment }
      ]
    }
  },

  computed: {
    ...mapState('checkout', {
      sectionComponent: state => state.section,
      topDiv: state => state.topDiv,
      hotelInCart: state => state.hotelInCart,
      number: state => state.number
    })
  },

  watch: {
    hotelInCart() {
      if (!this.hotelInCart) { this.sections.splice(3, 1) }
    }
  },

  async mounted() {
    // Delay Div load so it doesn't scroll to view on page load
    var current = this
    setTimeout(function() { current.setTopDiv(document.querySelector('.checkout-container')) }, 3000)
  },

  methods: {
    ...mapMutations('checkout', [
      'updateSection',
      'setTopDiv',
    ])
  }
}
</script>
